import React, { useState, useContext, useEffect } from 'react';

import {
  Button,
  TextField,
  Box,
  Typography,
  Container,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import Colors from '../../helpers/Colors';
import Assets from '../../helpers/assets';
import PasswordInput from './PasswordInput';
import { Auth } from 'aws-amplify';
import { AppContext } from '../../contexts/AppContext';
import { useHistory } from 'react-router';

export default function Login() {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [error, setError] = useState(null);
  const [isRequestSent, setRequestSent] = useState(false);

  const { authData, setAuth } = useContext(AppContext);
  const history = useHistory();

  const classes = useStyles();

  useEffect(() => {
    if (authData) {
        history.replace("/kitchenselect");
    }
  }, []);

  const onClickLogin = () => {

    const trimmedUsername = username ? username.trim() : '';
    const trimmedPassword = password ? password.trim() : '';

    if (!trimmedUsername || !trimmedPassword) {
      setError('Please check your login credentials');
    }
    if (trimmedUsername && trimmedPassword && !isRequestSent) {
      setRequestSent(true);
      setError(null);
      Auth.signIn(trimmedUsername, trimmedPassword)
      .then((response) => {
        setRequestSent(false);
          localStorage.setItem('dashboard_user', JSON.stringify({
          username: response.username,
          userDataKey: response.userDataKey,
          signInUserSession: response.signInUserSession,
        }));

        setAuth(response);
        // setLoggedIn(true);
        history.replace("/kitchenselect");
        // routerPush('/dispatcher/dashboard');
      })
      .catch((error) => {
        setError(error.message);
        setRequestSent(false);
      })
    }
  }

  return (
    <Box className={ classes.template }>
      <Container
        component="main"
        className={ classes.container }
      >
        <img
          src={ Assets.logoWhite.default }
          alt=""
          className={ classes.logo }
        />
        <Box className={ classes.titleContainer }>
          <Typography className={ classes.title }>
            Delivery Dashboard
          </Typography>
        </Box>

        <Box className={classes.paper}>
          <Box className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              placeholder="Enter Username"
              fullWidth
              onChange={(event) => setUsername(event.target.value)}
              id="username"
              label="USERNAME"
              name="username"
              className={ classes.usernameInput }
              autoFocus
            />
            <PasswordInput
              onChange={(value) => setPassword(value)}
            />
            
              <Button
                type="submit"
                fullWidth
                variant="contained"
                className={classes.submit}
                onClick={ onClickLogin }
              >
                {isRequestSent ? (
                  <CircularProgress size={ 22 } color="white" />
                ) : (
                  "LOGIN"
                )}
              </Button>
          </Box>
        </Box>
        {error && (
          <Box className={ classes.errorContainer }>
            <Typography className={ classes.errorText }>
              { error }
            </Typography>
            <img
              src={ Assets.error }
              alt=""
              className={ classes.errorIcon }
            />
          </Box>
        )}
      </Container>
    </Box>
  );
}


const useStyles = makeStyles((theme) => ({
  template: {
    minHeight: 600,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: 'rgba(34, 147, 249)',
    backgroundImage: `url(${Assets.loginBackground.default})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    margin: 0,
    padding: 0,
  },
  container: {
    marginTop: '8vh',
    height: '70vh',
    width: '40vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper: {
    width: '40vw',
    padding: 30,
    borderRadius: 8,
    maxWidth: 600,
    minWidth: 400,
    
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    minHeight: 250,

  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  usernameInput: {
    fontFamily: 'RobotoCondensed-Bold',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: Colors.blue,
    color: Colors.white,
    height: 45,
    fontSize: 18,
    boxShadow: 'none',
    fontFamily: 'SFProDisplay-Medium',
    '&:hover': {
      backgroundColor: Colors.blue,
      boxShadow: 'none',
    }
  },
  logo: {
    height: 50,
    width: '30vw',
    objectFit: 'contain',
    marginBottom: 10,
  },
  title: {
    fontSize: 22,
    color: Colors.white,
    fontFamily: 'SFProDisplay-Medium',
  },
  errorText: {
    color: Colors.white,
    fontSize: 17,
    fontFamily: 'SFProDisplay-Regular',
  },
  titleContainer: {
    padding: 5,
    paddingLeft: 40,
    paddingRight: 40,
    backgroundColor: Colors.blue,
    borderRadius: 22,
    marginTop: 5,
    marginBottom: 20,
  },
  alertBox: {
    marginTop: 50,
  },
  errorIcon: {
    height: 22,
    width: 22,
    objectFit: 'contain',
    marginLeft: 20,
  },
  errorContainer: {
    borderRadius: 13,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#DD2222',
    marginTop: 35,
    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 10,
    paddingBottom: 10,
  },
}));